/**
 * Poka-Yoke de construção do TPL — validação antes de salvar rotina
 */

export interface TplPokaYokeAnswers {
  geraValor: boolean;
  existeRisco: boolean;
  disciplinaPossivel: boolean;
  evidenciaObjetiva: boolean;
}

export const TPL_POKA_YOKE_QUESTIONS: Array<{
  key: keyof TplPokaYokeAnswers;
  label: string;
  hint: string;
}> = [
  {
    key: 'geraValor',
    label: 'Esta atividade gera valor direto para sua função?',
    hint: 'Deve contribuir para segurança, qualidade, entrega, custo ou desenvolvimento de pessoas.',
  },
  {
    key: 'existeRisco',
    label: 'Existe risco operacional se esta rotina não for executada?',
    hint: 'Considere impacto em segurança, qualidade, SLA ou continuidade.',
  },
  {
    key: 'disciplinaPossivel',
    label: 'É possível executar com disciplina na rotina real do turno?',
    hint: 'Avalie carga, conflitos de agenda e disponibilidade de equipe.',
  },
  {
    key: 'evidenciaObjetiva',
    label: 'Existe evidência objetiva de execução (registro, checklist, ata, foto)?',
    hint: 'TPL sustentável exige rastreabilidade auditável.',
  },
];

export interface TplPokaYokeResult {
  passed: boolean;
  failedCount: number;
  warningMessage: string | null;
}

export function validateTplPokaYoke(answers: TplPokaYokeAnswers): TplPokaYokeResult {
  const values = Object.values(answers);
  const failedCount = values.filter((v) => !v).length;
  const passed = failedCount === 0;

  return {
    passed,
    failedCount,
    warningMessage: passed
      ? null
      : 'Esta atividade pode não ser adequada para compor um Trabalho Padrão sustentável.',
  };
}

export const EMPTY_POKA_YOKE: TplPokaYokeAnswers = {
  geraValor: true,
  existeRisco: true,
  disciplinaPossivel: true,
  evidenciaObjetiva: true,
};
